const div = document.createElement('div');
div.className = 'effect-cover__measure';
document.body.appendChild(div);

let lock = null;

const nextTick = () => new Promise(resolve => { setTimeout(resolve, 0); });

const textNode = document.createTextNode('');
div.appendChild(textNode);

async function processAdjustSize(lower, higher, efc) {
    console.log(lower);
    console.log(higher);
    if (higher - lower <= .5) {
        return lower;
    }
    const { height } = efc;
    const fontSize = (lower + higher) / 2;

    if (fontSize < 12) {
        div.style.fontSize = '12px';
        div.style.transform = `translate(-50%,-50%) scale(${fontSize / 12}) translate(50%,50%)`;
        div.style.width = 12 / fontSize * efc.width + 'px';
    } else {
        div.style.fontSize = fontSize + 'px';
        div.style.transform = 'none';
        div.style.width = efc.width + 'px';
    }

    await nextTick();
    const bcr = div.getBoundingClientRect();

    if (bcr.height > height) {
        return processAdjustSize(lower, fontSize, efc);
    }

    return processAdjustSize(fontSize, higher, efc);
}

function setDivStyle(efc, fontSize, round) {
    div.style.cssText = '';

    const retStyle = div.style;
    retStyle.fontSize = fontSize + 'px';
    retStyle.lineHeight = efc.lineHeight;
    retStyle.textAlign = efc.align;
    if (fontSize < 12) {
        retStyle.fontSize = '12px';
        retStyle.transform = `translate(-50%,-50%) scale(${fontSize / 12}) translate(50%,50%)`;
        retStyle.width = 12 / fontSize * efc.width + 'px';
    } else {
        retStyle.width = efc.width + 'px';
    }

    retStyle.letterSpacing = (round ?
        Math.round(efc.letterSpacing / 100 * efc.fontSize || 0) / efc.fontSize
        : (efc.letterSpacing / 100 || 0)) + 'em';

    retStyle.fontFamily = efc.fontFamily + ",SourceHanSansCN-Regular,sans-serif";
    textNode.nodeValue = efc.text;
}

export async function adjustSize(efc, zoom, round) {
    if (lock) {
        console.log('adjustSize lock');
        return lock.then(() => new Promise((resolve) => {
            requestAnimationFrame(() => {
                resolve(adjustSize(efc, zoom));
            });
        }));
    }
    const fontSize = efc.fontSize / zoom;
    setDivStyle(efc, fontSize, round);

    let { height } = efc;
    let ret;
    height--;

    const bcr = div.getBoundingClientRect();
    if (!efc.fontSize) {
        console.log(efc);
    }

    if (bcr.height > height) {
        if (fontSize > 1) {
            console.log('down');
            const maxScale = height / bcr.height;
            lock = processAdjustSize(Math.max(fontSize * maxScale, 1), fontSize, efc);
        }
    } else {
        console.log('up');
        const maxScale = height / bcr.height;
        lock = processAdjustSize(fontSize, Math.min(fontSize * maxScale, Number.MAX_SAFE_INTEGER), efc);
    }

    ret = await lock;
    lock = null;

    if (ret) {
        console.log('calculated');
        console.log(ret);
        return Math.floor(ret * zoom);
    } else {
        return Math.floor(efc.fontSize);
    }
}

export default async function (efc, zoom, skipTrim, round = skipTrim, showRects = false) {
    if (lock) {
        await lock;
    }
    const re = skipTrim && efc.align !== 'justify' ? /\n\s*$/ : /\s+$/;
    const fontSize = efc.fontSize / zoom;
    setDivStyle(efc, fontSize, round);

    const range = document.createRange();
    range.setStart(textNode, 0);

    const ret = [];
    let count = 0;
    let prevEnd = 0;
    let breakPoints = [];
    let allRects = [];
    let prevBreakPoint = 0;

    for (let i = 0; i < efc.text.length; i++) {
        range.setEnd(textNode, i + 1);
        const rects = range.getClientRects();
        if (rects.length > count) {
            const last = count === 0 ? null : rects[count - 1];
            const wrapped = !last || rects[rects.length - 1].top - last.top > fontSize * .4;
            count = rects.length;
            if (wrapped) {
                if (last) {
                    // do not split at first character
                    // do not trim
                    ret.push(efc.text.slice(prevEnd, i).replace(re, ''));
                    console.log(last.width);
                    breakPoints.push(count - 1);
                }
                prevEnd = i;
            }
        }
        if (i === efc.text.length - 1) {
            allRects = rects;
        }
    }

    breakPoints.push(allRects.length);

    const retRects = breakPoints.map(pos => {
        const ret = [].slice.call(allRects, prevBreakPoint, pos);
        prevBreakPoint = pos;
        return ret;
    });

    const widths = retRects.map(rs => rs.reduce((prev, t) => prev + t.width, 0));

    ret.push(efc.text.slice(prevEnd, efc.text.length).replace(re, ''));
    console.log(ret);

    range.detach();

    return showRects ? { lines: ret, rects: retRects, widths } : ret;
}